export function formatRelativeDate(dateString) {
    if(!dateString)
        return null

    const date = new Date(dateString);
    const now = new Date();

    // Reset time portions to compare only dates
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const compareDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

    const diffMs = today - compareDate;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    // Today
    if (diffDays === 0) {
        return "today";
    }

    // Yesterday
    if (diffDays === 1) {
        return "1 day ago";
    }

    // Days ago (1-6 days)
    if (diffDays < 7) {
        return `${diffDays} days ago`;
    }

    // Weeks ago
    if (diffDays < 30) {
        const weeks = Math.floor(diffDays / 7);
        return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
    }

    // Months ago
    if (diffDays < 365) {
        const months = Math.floor(diffDays / 30);
        return months === 1 ? "1 month ago" : `${months} months ago`;
    }

    // Years ago
    const years = Math.floor(diffDays / 365);
    if(years)
        return years === 1 ? "1 year ago" : `${years} years ago`;

    return null
}
